import { ArrowLeft, ArrowRight, HelpCircle } from "lucide-react";
import { useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { Modal } from "./Modal";

export type TourStep = { selector: string; title: string; titleAr: string; body: string; bodyAr: string };

// Existing callers may still pass autoStart; help is always user initiated.
export function GuidedTour({ tourId, steps }: { tourId: string; steps: TourStep[]; autoStart?: boolean }) {
  const { isArabic } = useLanguage();
  const storageKey = `kidix_tour_${tourId}`;
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(() => {
    try { return Math.max(0, Math.min(Number(localStorage.getItem(`${storageKey}_step`)) || 0, steps.length - 1)); } catch { return 0; }
  });
  const step = steps[index];
  const changeStep = (next: number) => { setIndex(next); try { localStorage.setItem(`${storageKey}_step`, String(next)); } catch { /* Help also works without persistence. */ } };
  const close = () => setOpen(false);
  if (!step) return null;
  return <>
    <button className="tour-launcher" type="button" onClick={() => setOpen(true)} aria-haspopup="dialog" aria-label={isArabic ? "افتح دليل المساحة" : "Open workspace guide"}><HelpCircle aria-hidden="true" /><span>{isArabic ? "دليل" : "Guide"}</span></button>
    <Modal open={open} onClose={close} title={isArabic ? "دليل كيديكس" : "Kidix guide"}>
      <section className="workspace-guide">
        <p>{isArabic ? `الخطوة ${index + 1} من ${steps.length}` : `Step ${index + 1} of ${steps.length}`}</p>
        <div aria-live="polite" aria-atomic="true"><h3>{isArabic ? step.titleAr : step.title}</h3><p>{isArabic ? step.bodyAr : step.body}</p></div>
        <footer><button className="button button--outline" onClick={close}>{isArabic ? "إغلاق الدليل" : "Close guide"}</button><div>
          {index > 0 && <button className="button button--outline" onClick={() => changeStep(index - 1)}><ArrowLeft aria-hidden="true" />{isArabic ? "السابق" : "Back"}</button>}
          <button className="button button--dark" onClick={() => index === steps.length - 1 ? (changeStep(0), close()) : changeStep(index + 1)}>{index === steps.length - 1 ? (isArabic ? "إنهاء" : "Finish") : (isArabic ? "التالي" : "Next")}<ArrowRight aria-hidden="true" /></button>
        </div></footer>
      </section>
    </Modal>
  </>;
}